export interface Equipment {
  model: string;
  addon_id: string;
  addon?: string;
  quantity: number;
}

export interface Plan {
  id: string;
  name: string;
  quantity: number;
  trialPlan: boolean;
  pricing_model: "flat_fee" | "per_user";
  is_trial_plan: boolean;
  unit_price: number;
  total_price: number;
}

export enum SHOP_ITEM_TYPES {
  CONFIGURATION = 'configuration',
  EXTERNAL = 'external',
  PLAN_UPGRADE = 'plan_upgrade'
}

export interface ShopItem {
  type: SHOP_ITEM_TYPES.CONFIGURATION | SHOP_ITEM_TYPES.EXTERNAL | SHOP_ITEM_TYPES.PLAN_UPGRADE;
  // configuration
  default_addon?: string;
  // plan upgrade
  plan_upgrade_version?: string;
  // external and configuration
  description?: string;
  // for phone rental
  elements?: Equipment[];
}


export interface Shop {
  call_queue?: ShopItem;
  call_recording?: ShopItem;
  headphones_rental?: ShopItem;
  phone_rental?: ShopItem;
  channel?: ShopItem;
  number_portability?: ShopItem;
  credit_topup?: ShopItem;
  fax?: ShopItem;
  public_api?: ShopItem;
  voices_professional?: ShopItem;
  phone_number?: ShopItem;
  crm_integrations?: ShopItem;
  video_conference?: ShopItem;
}

export interface BundleAddon {
  addon: string;
  units_per_addon: number;
}
